import { Theme, styled } from "@material-ui/core/styles";
import { DownChevronIcon } from "../../../shared/icons";

export const Expand = styled(({ className }: { className: string }) => {
  return <DownChevronIcon className={className} />;
})(({ theme, expand }: { theme: Theme; expand: boolean }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "5 auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));
